import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import {
	Block,
	Text
} from '@emersya/mpa-components';

export interface IOMSPriceComponentConfiguration extends CM.DOMComponent.IConfiguration {
	type?: 'normal' | 'total';
	'@translations'?: CM.DOMComponent.IConfiguration['@translations'] & {
		prefix?: STD.translationsManager.TranslationMapping;
		suffix?: STD.translationsManager.TranslationMapping;
	};
};

export class OMSPriceComponent extends Block.Component<
	OMSPriceComponent,
	IOMSPriceComponentConfiguration
> {
	protected paths = {
		price: '@:price',
		ht: '@:ht'
	};

	protected refs!: Record<keyof OMSPriceComponent['paths'], unknown> & {
		price: Text.Component,
		ht: Text.Component
	};

	options!: {
		taxExcl?: boolean;
		currencyDisplay?: 'code' | 'symbol' | 'narrowSymbol' | 'name';
		trailingZeroDisplay?: 'auto' | 'stripIfInteger';
	};

	update(price: number | STD.math.BigNumber) {
		const priceFullPrecision = price instanceof STD.math.BigNumber ? price.toNumber() : price;
		const priceCropped = Math.trunc(STD.math.round(priceFullPrecision, 3) * 100) / 100;
		const intl = new Intl.NumberFormat(
			app.currentLanguage,
			{
				style: 'currency',
				currency: app.currentCurrency.id,
				currencyDisplay: this.options.currencyDisplay,
				trailingZeroDisplay: this.options.trailingZeroDisplay
			}
		);
		this.refs.price.update(intl.format(priceCropped));
		if (this.options.taxExcl) {
			this.refs.ht.component_DOM.classList.remove('notDisplayed');
		} else {
			this.refs.ht.component_DOM.classList.add('notDisplayed');
		}
	};

	override async component_initialize() {

		this.refs = <any>Object.fromEntries(
			Object.entries(this.paths).map(([key, path]) => [key, this.component_find(path)])
		);
		const omsBasket = app.modules.all.find(mod => mod.id === 'oms-basket');
		if (!omsBasket) {
			throw this.component_throwUserError('Cannot find oms-basket', {});
		}
		const options = this.component_configuration.type === 'normal' || !omsBasket.configuration.totalPriceFormat
			? omsBasket.configuration.priceFormat
			: omsBasket.configuration.totalPriceFormat;
		if (!options) {
			throw this.component_throwUserError('Missing priceFormat configuration for module oms-basket', {});
		}
		this.options = JSON.parse(options);
		await super.component_initialize();
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IOMSPriceComponentConfiguration
	) {
		if (!configuration['@innerConfigurations']) {
			configuration['@innerConfigurations'] = {};
		}
		if (!configuration['@innerConfigurations'].prefix) {
			configuration['@innerConfigurations'].prefix = {};
		}
		if (!configuration['@innerConfigurations'].suffix) {
			configuration['@innerConfigurations'].suffix = {};
		}
		if (configuration['@translations']?.prefix) {
			if (!configuration['@innerConfigurations'].prefix['@translations']) {
				configuration['@innerConfigurations'].prefix['@translations'] = {};
			}
			configuration['@innerConfigurations'].prefix['@translations'].text = configuration['@translations'].prefix;
		} else {
			configuration['@innerConfigurations'].prefix['@isDisabled'] = true;
		}
		if (configuration['@translations']?.suffix) {
			if (!configuration['@innerConfigurations'].suffix['@translations']) {
				configuration['@innerConfigurations'].suffix['@translations'] = {};
			}
			configuration['@innerConfigurations'].suffix['@translations'].text = configuration['@translations'].suffix;
		} else {
			configuration['@innerConfigurations'].prefix['@isDisabled'] = true;
		}
		super(descriptor, {type: 'normal', ...configuration});
	};
};
export namespace NS {
	export const Component = OMSPriceComponent;
	export type Component = OMSPriceComponent;
	export type Configuration = IOMSPriceComponentConfiguration;
}
import manifestXMLSource from './OMSPrice.xml';
import './OMSPrice.scss';

CM.Manager.declare({
	id: 'oms-price',
	type: OMSPriceComponent,
	manifest: manifestXMLSource
});
